import * as React from 'react';
import type { PlanChanges } from './models/DriverJobInterfaces';

interface DriverJobsSiteDeparturePlanChangesProps {
    planChanges: PlanChanges;
    isPickup: boolean;  //true if all jobs are pickups
    errors: any;
    updateNumber(fieldName: string, fieldValue: number): void;
    updateText(fieldName: string, fieldValue: string): void;
    updatePlan(planFile: File): void;
}

const DriverJobsSiteDeparturePlanChangesData = (props: DriverJobsSiteDeparturePlanChangesProps) => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e: any) => {
        props.updateNumber(e.target.name, e.target.value * 1);
    }

    const handleChangeText = (e: any) => {
        props.updateText(e.target.name, e.target.value);
    }

    const uploadplan = (e: any) => {
        props.updatePlan(e.target.files[0]);
    }

    
    let completeJob = props.planChanges;
    let planChanges = completeJob.planChanges * 1;

    return (
        <div>
            <div className={props.isPickup ? "hidden" : ""}>
                <label className="input-group alignitemscentre" htmlFor="planChanges">
                    <span className="label-mobile--inline margin5">Are there any plan changes?</span>
                    <input type="radio" className="marginRight10" id="yes" name="planChanges" value={1} checked={completeJob.planChanges === 1} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginRight10">Yes</span>
                    <input type="radio" className="marginRight10" id="no" name="planChanges" value={0} checked={completeJob.planChanges === 0} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical">No</span>
                </label>
                <span className="label errors">{props.errors["planChanges"]}</span>
            </div>
            <div className={planChanges === 0 ? "" : "hidden"}>
                <label className="input-group" htmlFor="notes">
                    <span className="label-mobile">Additional Notes - optional</span>
                    <textarea className="input marginLeft0 job__noteSize label-mobile" maxLength={500} id="notes" name="notes" value={completeJob.notes} onChange={(e) => handleChangeText(e)}></textarea>
                </label>
            </div>
            <div className={planChanges === 1 ? "" : "hidden"}>
                <label className="input-group" htmlFor="file">
                    <span className="label-mobile--inline margin5">Upload Photo of Plan</span>
                    <input className="marginLeft0" type="file" id="file" name="file" accept="image/*" onChange={uploadplan} />
                </label>
                <span className="label errors">{props.errors["plan"]}</span>
                <label className="input-group" htmlFor="planComments">
                    <span className="label-mobile--inline margin5">Comments</span>
                    <textarea className="input marginLeft0 notes__planChanges" maxLength={500} id="planComments" name="planComments" value={completeJob.planComments} onChange={(e) => handleChangeText(e)}></textarea>
                </label>
                <span className="label errors">{props.errors["planComments"]}</span>
            </div>
        </div>
    );

}

export default DriverJobsSiteDeparturePlanChangesData;